import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import NameCell from '@/components/table/NameCell';
import VisibilityCell from '@/components/table/VisibilityCell';

const CollectionDatasetAssignRow = ({
  dataset,
  className,
  removeDataset,
}) => (
  <Table.Row className={clsx('aridhia-collection-dataset-assign-row', className)}>
    <NameCell name={dataset.catalogue.title} icon="table" message="icon.dataset" />
    <VisibilityCell visibility={dataset.settings.visibility} />
    <Table.Cell collapsing>
      <RowDeleteButton entity="collection.dataset" floated="right" onClick={() => removeDataset(dataset.code)} />
    </Table.Cell>
  </Table.Row>
);

export default CollectionDatasetAssignRow;
